import { createDrawerStore } from '../drawer/createDrawerStore';

export const useOrderDrawerStore = createDrawerStore();
